import { mapGetters } from "vuex"

export default {
  data() {
    return {
      dialog: false
      //debug: false
    }
  },
  computed: {
    ...mapGetters(["champs"]),
    champ() {
      let found = this.champs.find((c) => c.code == this.code)
      if (found) {
        return found
      }
      return null
    },
    label() {
      return this.champ ? this.champ.label : ""
    },
    libelleLong() {
      // if (this.debug) {
      //   return this.code
      // }
      return this.champ ? this.champ.libelleLong : this.code ?? ""
    },
    descriptionPopup() {
      return this.champ ? this.champ.descriptionPopup : ""
    },
    catalogueReference() {
      return this.champ ? this.champ.catalogueReference : ""
    },
    modeAffichageCatalogue() {
      return this.champ ? this.champ.modeAffichageCatalogue : ""
    },
    idInner() {
      return this.id || this.code + "-" + Math.floor(Math.random() * 1000)
    }
  }
}